import PostsAdapter from './base';

export default class Studentnotice extends PostsAdapter {
  modelNamePlural = 'studentnotices';
}
